module.exports = __webpack_public_path__ + "img/engine.a8030581.jpg";